var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-arrow-wrapper"},[_c('p',{staticClass:"link"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"black"},on:{"click":_vm.goingToProp}},[_vm._v("mdi-arrow-left")]),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.text)))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }